<template>
    <div>
        <b-row>
            <b-col>
                <b-form @submit.prevent="salvar">
                    <b-card>
                        <b-form-row>
                            <img v-if="mostrarImagem && !this.busy" class="mt-3 ml-4 img-fluid" :src="form.imagem"
                                style="max-height: 100px !important" />
                        </b-form-row>

                        <b-form-row class="mt-4">
                            <b-col cols="9" class="ml-3">
                                <input type="file" class="form-control" id="imagemInput" accept="image/*"
                                    @change="visualizarImagem" />
                            </b-col>
                        </b-form-row>

                        <b-form-row class="mt-3">
                            <b-col cols="10" class="text-left">
                                <lg-form-input invalidFeedback="Informe o nome" description="" v-model="form.nome"
                                    label="Nome*" maxlength="200" />
                            </b-col>
                        </b-form-row>

                        <b-form-row>
                            <b-col cols="10" class="text-left">
                                <lg-form-input invalidFeedback="Informe a descrição" description=""
                                    v-model="form.descricao" label="Descrição*" maxlength="200" />
                            </b-col>
                        </b-form-row>

                        <b-form-group label="Situação:*" label-for="radio" class="ml-3">
                            <b-form-row>
                                <b-col cols="8">
                                    <b-form-radio-group id="radio" v-model="form.situacao" class="pt-2"
                                        :options="['Ativo', 'Inativo']"></b-form-radio-group>
                                </b-col>
                            </b-form-row>
                        </b-form-group>
                    </b-card>
                </b-form>
            </b-col>
        </b-row>

        <div class="images-container" v-if="modal">
            <div class="d-flex justify-content-center mt-3">
                <b-button id="salvarFotoIBP" @click="salvar" variant="success" style="height: 30px" pill size="sm">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="check-circle" />
                    </div>
                    <b-tooltip target="salvarFotoIBP" title="Salvar"></b-tooltip>

                </b-button>
                <b-button id="cancelarFotoIBForm" class="ml-2" @click="fecharModal" style="height: 30px" pill size="sm"
                    variant="danger">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="x-circle" />
                    </div>
                    <b-tooltip target="cancelarFotoIBForm" title="Cancelar"></b-tooltip>

                </b-button>
            </div>
        </div>
    </div>
</template>
<script>
import { getContext } from "@/core/auth"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import ResourceService from "@/core/api/ResourceService"

export default {
    components: {
        LgFormInput,
    },
    mixins: [FormResourceMixin, ListResourceMixin],
    props: {
        id: Number,
        modal: Boolean,
        edicao: Boolean,
        idFoto: Number,
    },
    data() {
        return {

            form: {
                descricao: "",
                nome: "",
                situacao: null,
                imagem: null,
                itemBemPermanente: { id: null },
            },
        };
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/foto-ibp`)
        this.form.itemBemPermanente = { id: this.id };

        if (this.edicao) {
            this.busy = true;
            this.$service.findById(this.idFoto).then(response => {
                var dataURL = "data:image/jpeg;base64," + response.data.arquivo;
                this.form = response.data;
                this.form.situacao = this.form.situacao == 1 ? "Ativo" : "Inativo";
                this.form.imagem = dataURL;
                this.busy = false;

            });
        }
    },

    computed: {
        mostrarImagem() {
            return this.form.imagem && this.form.imagem != null;
        },
    },

    methods: {
        visualizarImagem(event) {
            this.busy = true;
            this.form.imagem = null;

            var file = event.target.files[0];
            if (file) {
                var reader = new FileReader();
                reader.onload = e => {
                    this.form.imagem = e.target.result;
                    this.busy = false;
                 
                };
                reader.readAsDataURL(file);
            }
            
        },

        dataURItoBlob(dataURI) {
            var byteString = atob(dataURI.split(",")[1]);
            var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: mimeString });
        },
        async salvar() {
            if (!this.form.imagem) {
                this.$notify({
                    type: "danger",
                    message: "Selecione uma imagem",
                });

                return;
            }

            if (!this.form.nome || this.form.nome == "") {
                this.$notify({
                    type: "danger",
                    message: "Descrição é obrigatória",
                });

                return;
            }

            if (!this.form.descricao || this.form.descricao == "") {
                this.$notify({
                    type: "danger",
                    message: "Descrição é obrigatória",
                });

                return;
            }

            if (!this.form.situacao) {
                this.$notify({
                    type: "danger",
                    message: "Situação é obrigatória",
                });
                return;
            }

            this.form.itemBemPermanente = { id: this.id };

            var formData = new FormData();

            formData.append("itemBemPermanente.id", this.form.itemBemPermanente.id);
            formData.append("respCriacao", getContext().usuario.nome);
            formData.append("situacao", this.form.situacao == "Ativo" ? 1 : 0);
            formData.append("imagem", this.dataURItoBlob(this.form.imagem));
            formData.append("nome", this.form.nome);
            formData.append("descricao", this.form.descricao);

            try {
                await this.$saveResourceFormData(this.idFoto, formData, "", false);
                this.fecharModal();

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error,
                });

            }


        },
        fecharModal() {
            this.$emit("fecharModal");
        },

        editar() {
            this.$notify({
                type: "danger",
                message:
                    "Esse registro não pode ser editado. Por favor, inclua um novo",
            });
        },
    },
};
</script>
<style>
.hand-pointer {
    cursor: pointer;
}
</style>
